import React from 'react';
import {useTranslation} from "react-i18next";

const FidelityPts = (props) => {
    const { t,i18n } = useTranslation();
    if(!props.account.proxiCardBalance){
        return null;
    }
    return (
        <div className="fidelitypts">
            <span className="fidelitypts__icon">
                  <i className="far fa-coins"></i>
            </span>
            <span className="fidelitypts__text">{t('header.fidelitypts')}</span>
            <span className="fidelitypts__icon fidelitypts__icon--arrow">
                <i className="fas fa-caret-right"></i>
            </span>
            <span className="fidelitypts__balance">
                {props.account.proxiCardBalance.value}
            </span>
            <span className="fidelitypts__link">
             <a href={`https://proxiextra.datacandyinfo.com/login?lang=${i18n.lang}_CA`}
                                                        target="_blank">{t('header.consultpts')}</a>
            </span>
        </div>
    );
};

export default FidelityPts;
